import { mapActions, mapGetters, mapMutations } from "vuex";
import { email, maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";

export default {
    name: "set-password",
    data() {
        return {
            payload: {
                password: "",
                password_confirmation: "",
                code: null,
                token: null,
                email: this.$route.query.email,
                phone: this.$route.query.phone,
            },
            validationErrors: {},
        };
    },
    validations() {
        if (this.$route.query.hasOwnProperty("email")) {
            return {
                payload: {
                    password: {
                        required,
                        minLength: minLength(8),
                        maxLength: maxLength(20),
                    },
                    password_confirmation: {
                        maxLength: maxLength(20),
                        required,
                        sameAsPassword: sameAs("password"),
                    },
                },
            };
        }
        if (this.$route.query.hasOwnProperty("phone")) {
            return {
                payload: {
                    password: {
                        required,
                        minLength: minLength(8),
                        maxLength: maxLength(20),
                    },
                    password_confirmation: {
                        maxLength: maxLength(20),
                        required,
                        sameAsPassword: sameAs("password"),
                    },
                    code: {
                        required,
                        minLength: minLength(6),
                        maxLength: maxLength(6),
                    },
                },
            };
        }
    },
    components: {},
    computed: {
        ...mapGetters({
            setNewPasswordLoading: "auth/setNewPasswordLoading",
            popupSetNewPassword: "auth/showSetNewPassword",
            popupRegister: "auth/popupRegister",
        }),
        passwordErrors() {
            let error = [];
            if (!this.$v.payload.password.$dirty) {
                return error;
            }
            if (!this.$v.payload.password.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.password.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.password.minLength) {
                error.push(this.$t("validationMin").replace(":count", 8));
            }
            if (this.validationErrors.password) {
                this.validationErrors.password.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        passwordConfirmationErrors() {
            let error = [];
            if (!this.$v.payload.password_confirmation.$dirty) {
                return error;
            }
            if (!this.$v.payload.password_confirmation.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.password_confirmation.sameAsPassword) {
                error.push(this.$t("validationSameAs"));
            }
            if (this.validationErrors.password_confirmation) {
                this.validationErrors.password_confirmation.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        codeErrors() {
            let error = [];
            if (!this.$v.payload.code.$dirty) {
                return error;
            }
            if (!this.$v.payload.code.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.code.minLength) {
                error.push(this.$t("validationMin") + " 6");
            }
            if (!this.$v.payload.code.maxLength) {
                error.push(this.$t("validationMax") + " 6");
            }
            if (this.validationErrors.code) {
                this.validationErrors.code.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.$route.query.hasOwnProperty("email")) {
                if (this.payload.password === "" && this.payload.password_confirmation === "") {
                    return true;
                }
                return false;
            }

            if (this.$route.query.hasOwnProperty("phone")) {
                if (
                    this.payload.password === "" &&
                    this.payload.password_confirmation === "" &&
                    this.payload.code === ""
                ) {
                    return true;
                }
                return false;
            }
        },
    },
    methods: {
        ...mapActions({
            setPassword: `auth/SET_NEW_PASSWORD`,
        }),
        ...mapMutations({
            showPopup: `auth/CHANGE_POPUP_RESTORE_PASSWORD`,
            changeSetNewPassword: `auth/CHANGE_POPUP_SET_NEW_PASSWORD`,
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let obj = {};

                if (this.$route.query.hasOwnProperty("email")) {
                    obj.password = this.payload.password;
                    obj.password_confirmation = this.payload.password_confirmation;
                    obj.token = this.$route.query.token;
                    obj.email = this.$route.query.email;
                    this.setPassword(obj)
                        .then(() => {
                            this.$toasted.success(this.$t("successChangePassword"));
                            this.changeSetNewPassword(false);
                            this.$router.replace({ query: null });
                            setTimeout(() => {
                                this.changePopupRegister({ show: true, isRedirect: false });
                            }, 500);
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                Object.assign(this.validationErrors, error.response.data.errors);
                            }
                            if (error.response.status === 400) {
                                this.$toasted.error(error.response.data.message);
                            }
                        });
                }

                if (this.$route.query.hasOwnProperty("phone")) {
                    obj.password = this.payload.password;
                    obj.password_confirmation = this.payload.password_confirmation;
                    obj.token = this.payload.code;
                    obj.phone = this.$route.query.phone;
                    this.setPassword(obj)
                        .then(() => {
                            this.$toasted.success(this.$t("successChangePassword"));
                            this.changeSetNewPassword(false);
                            this.$router.replace({ query: null });
                            setTimeout(() => {
                                this.changePopupRegister({ show: true, isRedirect: false });
                            }, 500);
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                Object.assign(this.validationErrors, error.response.data.errors);
                            }
                            if (error.response.status === 400) {
                                this.$toasted.error(error.response.data.message);
                            }
                        });
                }
            }
        },
    },
    destroyed() {
        this.$router.replace({ query: null });
    },
};
